export default "__VITE_ASSET__ALsFb2Uf__"